import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'i18n'
import useA11yEnabled from 'utils/hooks/use-a11y-enabled'
import { MAIN_CONTENT_ID } from './constants'

const SkipLink = () => {
  const { t } = useTranslation()
  const { a11yEnabled } = useA11yEnabled()
  const [container] = useState(() => {
    const element = document.createElement('div')
    element.dataset.skipLinkRoot = 'true'
    return element
  })

  useEffect(() => {
    if (!a11yEnabled) return

    document.body.insertBefore(container, document.body.firstChild)

    return () => container.remove()
  }, [container, a11yEnabled])

  if (!a11yEnabled) return null

  return createPortal(
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100000] focus:rounded-medium focus:bg-white focus:px-4 focus:py-3 focus:font-bold focus:text-gray-900 focus:shadow-lg focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-gray-900"
      data-testid="skip-link"
    >
      {t('Pular para o conteúdo')}
    </a>,
    container
  )
}

export default SkipLink
